import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChecklistModel, QUESTION_TYPE, Question } from '../../../interface/checklist-model';
import { MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { AddChecklistQuestionComponent } from '../add-checklist-question/add-checklist-question.component';
import { first } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

/**
  * Optional injections can't be used with optional property operator (?)
  *
  * do:
  * @Optional() @Inject(MAT_DIALOG_DATA) private data: any
  *
  *
  * don't:
  * @Inject(MAT_DIALOG_DATA) private data?: any
  *
  **/
@Component({
  selector: 'app-add-checklist-model',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,

    MatDialogContent,
    MatFormFieldModule,
    MatLabel,
    MatTableModule,
    MatIconModule,
    MatDialogActions,
    MatDialogClose,
    MatInputModule,
    MatButtonModule,
    MatDialogTitle
  ],
  templateUrl: './add-checklist-model.component.html',
  styleUrls: ['./add-checklist-model.component.scss']
})
export class AddChecklistModelComponent implements OnInit {

  QUESTION_TYPE = QUESTION_TYPE;

  form: FormGroup = new FormBuilder().group({
    _id: "",
    group: "",
    // url: "",
    // defaultText: "",
    questions: [[]]
  });


  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) private data: ChecklistModel,
    private _dialog: MatDialog
  ) { }

  ngOnInit() {
    if (this.data) {
      this.form.patchValue(this.data)
    }
  }

  set questions(questions: Question[]) {
    this.form.get('questions').setValue(questions.slice());
  }

  get questions(): Question[] {
    return this.form.get('questions').value || [];
  }

  public addQuestion() {
    const questions = this.questions;
    this._dialog.open(AddChecklistQuestionComponent, {
      minWidth: '50vw'
    }).afterClosed()
      .pipe(first())
      .subscribe(question => {
        if (question) {
          questions.push(question);
          this.questions = questions;
        }
      });
  }

  public editQuestion(question: Question) {
    const index = this.questions.indexOf(question);
    this._dialog.open(AddChecklistQuestionComponent, {
      data: question,
      minWidth: '50vw'
    }).afterClosed()
      .pipe(first())
      .subscribe(updatedQuestion => {
        if (updatedQuestion) {
          this.questions[index] = updatedQuestion;
          this.questions = this.questions; // update table
        }
      });
  }

  removeQuestion(index: number) {
    const questions = this.questions;
    questions.splice(index, 1);
    this.questions = questions;
  }

}
